// Number of obstacles prefetched on each side of the selected one.
export const OBSTACLE_THUMBNAIL_WINDOW_RADIUS = 2;

/**
 * Build the list of obstacle indexes whose thumbnails should be fetched.
 *
 * The window is centered on the selected obstacle and truncated at both ends so
 * it never points past the obstacles actually present in the session. Sessions
 * with fewer obstacles than the window size return a shorter list instead of
 * out of range indexes.
 *
 * @param  {Number} centerIndex   Index of the currently selected obstacle
 * @param  {Number} totalObstacles Number of obstacles in the session
 * @param  {Number} windowRadius  Obstacles to prefetch on each side
 * @return {Array}                Valid obstacle indexes, ascending
 */
export function getObstacleThumbnailWindow(
  centerIndex,
  totalObstacles,
  windowRadius = OBSTACLE_THUMBNAIL_WINDOW_RADIUS,
) {
  const total = Number.isInteger(totalObstacles) ? totalObstacles : 0;
  const isCenterInRange =
    Number.isInteger(centerIndex) && centerIndex >= 0 && centerIndex < total;
  if (total <= 0 || !isCenterInRange) return [];

  const start = Math.max(0, centerIndex - windowRadius);
  const end = Math.min(total, centerIndex + windowRadius + 1);

  return Array.from({ length: end - start }, (_, offset) => start + offset);
}
